module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarmsgoldleafandhandletteredantiquemirror2018.ae28aee3.webp";